







































import { Component, Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import VariantData from '@/ts/VariantData';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        FlexibleTable,
    },
})
export default class VariantList extends Vue {
    public tableEntity: string = 'VariantList';

    public defaultTableConfig: TableViewConfig = {
        visibleColumns: [
            'id',
            'name',
            'rooms',
            'area',
            'projectName',
        ],
    };

    constructor() {
        super();
    }

    get columns(): any {
        return [
            {
                name: 'id',
                label: this.$t('general.unit-type-id', 'Unit Type ID'),
                align: 'left',
                field: 'id',
                sortable: true,
                required: true,
            },
            {
                name: 'name',
                label: this.$t('general.unit-type', 'Unit type'),
                align: 'left',
                field: 'name',
                sortable: true,
                required: false,
            },
            {
                name: 'rooms',
                label: this.$t('general.rooms', 'Rooms'),
                align: 'left',
                field: 'rooms',
                sortable: true,
                required: false,
            },
            {name: 'area', label: 'm²', align: 'left', field: 'area', sortable: true, required: false},
            {
                name: 'projectName',
                label: this.$t('general.project-name', 'Project name'),
                align: 'left',
                field: 'projectName',
                sortable: true,
                required: false,
            },
        ];
    }

    get getVariantData(): VariantData[] {
        return this.$store.getters['Variants/allVariants'].filter((variant: VariantData) => variant.persisted);
    }

    get selectedProjects(): number {
        return this.$store.getters['Projects/selectedProjects'];
    }

    get filteredByProjects(): VariantData[] {
        const projectId = this.$store.state.Projects.activeProjectId;

        return this.getVariantData.filter((item: any) => item.projectId === projectId);
    }

    get filteredVariants(): VariantData[] {
        return this.$store.state.Projects.activeProjectId !== null ? this.filteredByProjects : this.getVariantData;
    }

    public deleteVariant(variantId: number, variantName: any): void {
        this.$store.commit(Mutations.SET_CONFIRM_POPUP_DATA, {
            confirmAction: 'Variants/DELETE_UNIT_TYPE',
            confirmActionData: { variantId },
            confirmQuestionText: this.$t('confirmation.are-you-sure-you-want-to-delete-this-unit-type', 'Are you sure you want to delete this unit type?'),
            confirmInfoText: variantName,
            confirmButton: this.$t('forms.delete', 'Delete'),
            confirmIconVisibility: true,
            confirmIcon: 'fa-trash',
            confirmHeaderText: this.$t('forms.delete-unit-type', 'Delete unit type'),
            confirmButtonClass: 'hococo-close-form-btn',
        });
    }

    public slideInForm(formKey: string, itemId: any) {
        this.$store.commit(Mutations.UPDATE_ACTIVE_VARIANT, itemId);
        this.$store.commit(Mutations.EDIT_ACTIVE_VARIANT);
        this.$store.commit(Mutations.SHOW_EDIT_VARIANT_FORM, formKey);
    }

    public uploadFloorPlan(itemId: any) {
        this.$store.commit(Mutations.UPDATE_ACTIVE_VARIANT, itemId);
        this.$store.dispatch(Actions.GET_ADMIN_FLOOR_PLAN, itemId);
        this.$store.commit(Mutations.SHOW_UPLOAD_FLOOR_PLAN_FORM);
    }

    public loadFloorPlan(variantData: any) {
        if (variantData.hasFloorPlan !== false) {
            return true;
        } else {
            return false;
        }
    }
}
